<template>
    <div style="margin-bottom: 20px;">
        <pdf ref="pdf" v-for="i in numPages" :key="i" :src="loadingTask" :page="i">
        </pdf>
    </div>
</template>

<script>
    import pdf from 'vue-pdf'

    export default {
        data() {
            return {
                // 引入pdf
                loadingTask: '',
                numPages: 1,
            }
        },
        props: {
            pdf_url: {
                type: String,
                default: ''
            }
        },
        components: {
            pdf
        },
        created() {
            this.getPdfData()
        },
        methods: {
            getPdfData() {
                const loadingTask = pdf.createLoadingTask(this.pdf_url);
                this.loadingTask = loadingTask
                loadingTask.promise.then(pdf => {
                    this.numPages = pdf.numPages;
                });
            },
        }
    }
</script>

<style scoped>
</style>